import { Layout, Avatar, Dropdown } from "antd";
import { UserOutlined } from "@ant-design/icons";
import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./theme.less";

const CONN_KEY = process.env.REACT_APP_NOT_SECRET_CODE_R;
const { Header } = Layout;

const Headers = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const username = localStorage.getItem("username");

    localStorage.removeItem("username");
    localStorage.removeItem("s");
    localStorage.removeItem("_i_");

    try {
      await axios.post(CONN_KEY + "Logout.php", { logout: true, username });
    } catch (e) {
      console.error("Logout error:", e);
    } finally {
      navigate("/");
    }
  };

  const username = localStorage.getItem("username");

  // ✅ AntD v5 Dropdown üçün menu items
  const items = [
    {
      key: "logout",
      label: (
        <span
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleLogout();
          }}
          style={{ color: "#ED3F3F", cursor: "pointer" }}
        >
          Çıxış
        </span>
      ),
    },
  ];

  return (
    <Dropdown
      trigger={["click"]}
      menu={{ items }}
      placement="bottomRight"
    >
      {/* ✅ Dropdown child mütləq 1 element olmalıdır */}
      <span style={{ display: "inline-flex" }}>
        <Avatar style={{ color: "#fff", marginRight: 20, cursor: "pointer" }}>
          {username ? username.charAt(0).toUpperCase() : <UserOutlined />}
        </Avatar>
      </span>
    </Dropdown>
  );
};

export default Headers;
